import { render, staticRenderFns } from "./HKBanksInfo.vue?vue&type=template&id=1940bd17&scoped=true&"
import script from "./HKBanksInfo.vue?vue&type=script&lang=js&"
export * from "./HKBanksInfo.vue?vue&type=script&lang=js&"
import style0 from "./HKBanksInfo.vue?vue&type=style&index=0&id=1940bd17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1940bd17",
  null
  
)

export default component.exports